// extracted by mini-css-extract-plugin
export default {"labelClass":"labelClass---ln8dW","separator":"separator---N0FRn"};